<template>
  <div id="animate-nav" class="top-navbar">
    <div class="section-content">
      <nav class="navbar">
        <div class="d-flex flex-row" style="cursor: pointer" @click="scrollToSection('section-banner', -1)">
          <img src="../assets/logo.png" class="brand-logo" alt="">
          <div class="flex-column" style="align-self: center;margin-left: 10px">
            <div class="brand-title">建个会</div>
            <div class="brand-sub-title">安全做会就用建个会</div>
          </div>
        </div>
        <nav class="nav d-none d-lg-flex">
          <div class="d-inline-flex" style="margin-left: 40px" v-for="(item,index) in navbars" :key="index">
            <div v-if="index===navSelected" class="d-flex navbar-item-selected">
              <div style="align-self: center">{{item.name}}</div>
            </div>
            <div v-else class="d-flex navbar-item" v-on:click="scrollToSection(item.id, index)">
              <div style="align-self: center">{{item.name}}</div>
            </div>
          </div>
        </nav>
        <nav class="nav d-lg-none">
          <transition name="fade">
            <div class="d-flex ms-app-down" v-if="navDownBtn && from!=='app'">
              <button v-if="isWxMiniProgram" id="copy" type="button" class="btn btn-success"
                      :data-clipboard-text="apkUrl">下载 APP
              </button>
              <button v-else type="button" class="btn btn-success" @click="downloadApp">下载 APP</button>
            </div>
          </transition>
        </nav>
      </nav>
    </div>
  </div>
</template>

<script>
  let TWEEN = require('@tweenjs/tween.js');
  let VueScrollTo = require('vue-scrollto');
  import Bus from '../Bus';
  import Clipboard from 'clipboard';

  export default {
    name: "NavigationBar",
    props: ["from", "apkUrl"],
    methods: {
      handleScroll() {
        if ((window.scrollY >= 20 && this.lastScrollY < 20) || (window.scrollY < 20 && this.lastScrollY > 20)) {
          let style, style_end;
          let end_alpha = window.innerWidth > 992 ? 0 : 1;
          let max_padding = window.innerWidth > 992 ? 10 : 20;
          if (window.scrollY >= 20 && this.lastScrollY < 20) {
            style = {padding: max_padding, shadowAlpha: 0, colorAlpha: end_alpha};
            style_end = {padding: 0, shadowAlpha: 0.1, colorAlpha: 1};
          } else {
            style = {padding: 0, shadowAlpha: 0.1, colorAlpha: 1};
            style_end = {padding: max_padding, shadowAlpha: -1, colorAlpha: end_alpha};
          }
          let navbarEL = document.querySelector('#animate-nav');
          new TWEEN.Tween(style)
            .to(style_end, 200)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate(function () {
              if (style && navbarEL) {
                let shadow = '0 0 15px rgba(0, 0, 0, ' + style.shadowAlpha + ')';
                let bgColor = 'rgba(249, 254, 252, ' + style.colorAlpha + ')';
                navbarEL.style.setProperty('padding-top', style.padding + 'px');
                navbarEL.style.setProperty('padding-bottom', style.padding + 'px');
                navbarEL.style.setProperty('box-shadow', shadow);
                navbarEL.style.setProperty('-webkit-box-shadow', shadow);
                navbarEL.style.setProperty('-moz-box-shadow', shadow);
                navbarEL.style.setProperty('background-color', bgColor);
              }
            }).start();
        }

        this.navDownBtn = window.scrollY >= 400;
        this.lastScrollY = window.scrollY;

        if (window.innerWidth > 992) {
          if (!this.autoScroll) {
            if (this.lastScrollY < 600) {
              this.navSelected = -1
            } else if (this.lastScrollY < 1600) {
              this.navSelected = 0
            } else if (this.lastScrollY < 2600) {
              this.navSelected = 1
            } else {
              this.navSelected = 2
            }
          }
        }
      },

      scrollFinished() {
        this.autoScroll = false;
        console.log(this.autoScroll);
      },

      scrollToSection(id, index) {
        this.navSelected = index;
        this.autoScroll = true;
        VueScrollTo.scrollTo('#' + id, 500);
        if (this.scrollTimer !== -1) {
          clearTimeout(this.scrollTimer);
        }
        this.scrollTimer = window.setTimeout(this.scrollFinished, 500);
      },

      downloadApp() {
        this.$emit("download")
      },
    },

    mounted() {
      window.addEventListener('scroll', this.handleScroll);

      function animate(time) {
        requestAnimationFrame(animate);
        TWEEN.update(time);
      }

      requestAnimationFrame(animate);

      let that = this;
      Bus.$on('pageScrollTop', function () {
        that.scrollToSection('section-banner', -1);
      });

      new Clipboard('#copy').on('success', (e) => {
        e.clearSelection();
        this.weui.alert("已复制下载链接，请使用手机自带浏览器下载", () => {
          this.weui.toast("已复制", 1000);
        });
      });
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          this.isWxMiniProgram = true;
        }
      })
    },

    data() {
      return {
        lastScrollY: 0,
        navSelected: -1,
        navDownBtn: false,
        autoScroll: false,
        navIsFloat: false,
        scrollTimer: -1,
        navbars: [
          {id: 'section-product', name: '产品介绍'},
          {id: 'section-service', name: '特色服务'},
          {id: 'section-about', name: '关于我们'}
        ],
        isWxMiniProgram: false,
      }
    }
  }
</script>

<style scoped>
  @media (min-width: 992px) {
    .section-content {
      max-width: 60%;
    }

    .top-navbar {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 200;
      padding: 20px 0;
    }

    .brand-title {
      font-size: 24px;
      line-height: 25px;
      color: #333;
      text-align: left;
      font-family: "PingFang SC", serif;
      font-weight: bold;
    }

    .brand-sub-title {
      margin-top: 4px;
      font-size: 14px;
      line-height: 14px;
      color: #878787;
      text-align: left;
    }

    .brand-logo {
      border-radius: 5px;
      width: 48px;
      height: 48px;
    }

    .navbar-item {
      font-size: 16px;
      color: #000;
      margin: auto;
      cursor: pointer;
      padding: 10px 0;
      border-bottom: transparent solid 4px;
    }

    .navbar-item:hover {
      color: #14c886;
    }

    .navbar-item-selected {
      font-size: 16px;
      color: #14c886;
      margin: 0 auto;
      cursor: default;
      padding: 10px 0;
      border-bottom: #14c886 solid 4px;
    }
  }

  @media (max-width: 992px) {
    .top-navbar {
      width: 100%;
      background-color: #f9fefc;
      position: fixed;
      top: 0;
      z-index: 200;
      padding: 10px 0;
    }

    .brand-title {
      font-size: 16px;
      line-height: 16px;
      color: #333;
      text-align: left;
      font-family: "PingFang SC", serif;
      font-weight: bold;
    }

    .brand-sub-title {
      margin-top: 4px;
      font-size: 12px;
      line-height: 12px;
      color: #878787;
      text-align: left;
    }

    .brand-logo {
      border-radius: 5px;
      width: 36px;
      height: 36px;
    }

    .ms-app-down > button {
      font-size: 12px;
      font-family: "Tahoma", "宋体", "sans-serif";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue